module.exports = __webpack_public_path__ + "img/result-detail-last-message02.cbddee1c.svg";